// extracted by mini-css-extract-plugin
module.exports = {"root":"GlobalAlertContainer_root__2Szvd"};